var map = {
	"./ccp.png": 7615,
	"./formosa.png": 5673,
	"./huafon.png": 3204,
	"./lgchem.png": 2317,
	"./lotte.png": 93,
	"./wanhua.png": 6132,
	"./zislloy.png": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5080;